// extracted by mini-css-extract-plugin
module.exports = {"page":"ziFCyk","withAffordance":"AxCE8w"};